import { Stack, Tooltip } from "@mui/material";
import React from "react";
import GlobalSearch from '../../components/Search';
import gridActiveIcon from "../../styles/svg/grid-view-active.svg";
import gridInactiveIcon from "../../styles/svg/grid-view-inactive.svg";
import listActiveIcon from "../../styles/svg/list-view-active.svg";
import listInactiveIcon from "../../styles/svg/list-view-inactive.svg";
import { useWatchingViewToggle } from "./hooks/useWatchingViewToggle";

export const DeskTopHeader = ({ handleChange, inputValue, TooltipName }) => {
    const { gridView, handleGridView, handleListView } = useWatchingViewToggle();

    return (
        <Stack direction="row" justifyContent="space-between" mb={1}>
            <p className="board-heading-name">Watching Tasks</p>
            <Stack direction="row" alignItems={"center"}>
                <Stack className="grid-list-cont mr-2">
                    <Tooltip title={TooltipName.KANBAN_VIEW}>
                        <img
                            src={gridView ? gridActiveIcon : gridInactiveIcon}
                            alt="gridIcon"
                            onClick={handleGridView}
                        />
                    </Tooltip>
                    <Tooltip title={TooltipName.LIST_VIEW}>
                        <img
                            src={gridView ? listInactiveIcon : listActiveIcon}
                            alt="listIcon"
                            onClick={handleListView}
                        />
                    </Tooltip>
                </Stack>
                <GlobalSearch
                    placeholder={"Search.."}
                    searchText={inputValue}
                    handleChange={handleChange}
                />
            </Stack>
        </Stack>
    )
}

